import React, {useEffect, useState} from 'react';
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import Banner from "../../../../../assets/images/BreachRisk_Technical_Banner.svg";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {useDispatch, useSelector} from "react-redux";
import {
    bbDangerousStringToDate,
    bbDoesCustomerHaveAccessToSubscriptionLevel,
    bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity,
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindCustomerTagsByTagId,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbIsEntityAwaitingFirstScoreCycle,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor,
    isCurrentUserMemberOf
} from "../../../../../util/bbHelpers";
import {Badge, Col, Row} from "reactstrap";
import Skeleton from "react-loading-skeleton";
import BRThreatsTechnicalTable
    from "../../../../../components/customBreachBits/BreachRiskReport/BRThreatsTechnicalTable";
import TileBreachRiskTechDataCountServices
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataCountServices";
import TileBreachRiskTechDataNumTargets
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataNumTargets";
import TileBreachRiskTechDataNumVulnerableTargets
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataNumVulnerableTargets";
import TileBreachRiskTechDataNumSubdomains
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataNumSubdomains";
import BRServicesTechnicalTable
    from "../../../../../components/customBreachBits/BreachRiskReport/BRServicesTechnicalTable";
import BRSubdomainsTechnicalTable
    from "../../../../../components/customBreachBits/BreachRiskReport/BRSubdomainsTechnicalTable";
import TileBreachRiskTechDataPieAllServices
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataPieAllServices";
import TileBreachRiskTechDataPieVectorTypes
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataPieVectorTypes";
import TileBreachRiskTechDataPieAllPorts
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataPieAllPorts";
import BreachRiskScoreCyclePendingModal
    from "../../../../../components/customBreachBits/modals/BreachRiskScoreCyclePendingModal";
import BRTechnicalTargetsTable
    from "../../../../../components/customBreachBits/BreachRiskReport/BRTechnicalTargetsTable";
import BRFidelityBadge from "../../../../../components/customBreachBits/BRPortfolio/BRFidelityBadge";
import BRVulnerabilitiesTable from "../../../../../components/customBreachBits/BreachRiskReport/BRVulnerabilitiesTable";
import TileBreachRiskTechDataPieVectorServices
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataPieVectorServices";
import TileBreachRiskTechDataPieVectorStatus
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataPieVectorStatus";
import TileComingSoon from "../../../../../components/customBreachBits/metrics/TileComingSoon";
import VerifiedOwnershipRequiredDialog
    from "../../../../../components/customBreachBits/OnboardingProgress/VerifiedOwnershipRequiredDialog";
import DisableChildrenIfDoesntHaveAccessToSubscriptionLevel
    from "../../../../../components/customBreachBits/modals/DisableChildrenIfDoesntHaveAccessToSubscriptionLevel";
import TileBreachRiskTechDataNumVulnerabilities
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataNumVulnerabilities";
import TileBreachRiskTechDataCountHighRiskServices
    from "../../../../../components/customBreachBits/metrics/TileBreachRiskTechDataCountHighRiskServices";
import CyberspaceTechHistoryCharts from "../../../../../components/customBreachBits/charts/AttackSurfaceTrendsTechHistoryChart";
import CyberspaceTechHistoryChart from "../../../../../components/customBreachBits/charts/AttackSurfaceTrendsTechHistoryChart";
import EarlyAccessWrapper from "../../../../../components/customBreachBits/settings/EarlyAccessWrapper";
import ThreatVectorsTechHistoryChart
    from "../../../../../components/customBreachBits/charts/ThreatVectorsTechHistoryChart";
import AttackSurfaceTrendsTechHistoryChart
    from "../../../../../components/customBreachBits/charts/AttackSurfaceTrendsTechHistoryChart";
import CycleProgressStepper from "../../../../../components/customBreachBits/info/CycleProgressStepper";
import BRCompanyScopeProgressBadge
    from "../../../../../components/customBreachBits/BBRiskMeter/BRCompanyScopeProgressBadge";
import BRCompanyScoreVerifiedBadge
    from "../../../../../components/customBreachBits/BBRiskMeter/BRCompanyScoreVerifiedBadge";
import {fetchCycleSocialPagewise, fetchRiskCycleDetailsPagewise, fetchRiskCycleReport} from "../../../../../actions";
import Select from "react-select";

const Dashboard= ({
    portfolioView = false
                  }) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView, loadingCycles, loadingCycleDetails} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);
    const isAdmin = isCurrentUserMemberOf(authUser, "admin");
    const dispatch = useDispatch();

    // const isTrustedAgent = bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel3");
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const isCycleOngoing = myEntity
        && myEntity.settings
        && myEntity.settings.ongoing_cycle_complete_datetime;

    // const riskScore = myEntity && myEntity.last_cycle ? myEntity.last_cycle.score : null;
    const confidenceLow = myEntity && myEntity.last_cycle ? parseFloat(myEntity.last_cycle.confidence_low).toFixed(1) : null;
    const confidenceHigh = myEntity && myEntity.last_cycle ? parseFloat(myEntity.last_cycle.confidence_high).toFixed(1) : null;
    const breachRiskScore = myEntity && myEntity.last_cycle ? myEntity.last_cycle.score : null;
    const breachRiskCategory = bbTranslateBreachRiskScoreToCategory(breachRiskScore);
    const hasPremiumSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 11);
    const isAdminStaff = isCurrentUserMemberOf(authUser,"admin") || isCurrentUserMemberOf(authUser, "staff");

    const ownershipVerified = myEntity
        && myEntity.onboarding_progress
        && myEntity.onboarding_progress.verified_ownership;

    // const fidelityCategory = bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory(confidenceLow, confidenceHigh);

    const historyData = (myEntity
        && myEntity.history
        && Array.isArray(myEntity.history))
        ? myEntity.history
        :null;

    const sortedHistory = historyData && historyData
        .sort((a,b) => (bbDangerousStringToDate(a.cycle_date) > bbDangerousStringToDate(b.cycle_date) ? 1 : -1))

    const [cycleInView, setCycleInView] = useState( myEntity
        && myEntity.last_cycle
        && myEntity.last_cycle.cycle);
    const [isPastReport, setIsPastReport] = useState(cycleInView !== (myEntity && myEntity.last_cycle && myEntity.last_cycle.cycle))

    const techData = myEntity
    && myEntity.last_cycle
    && myEntity.last_cycle.cycle
    && myEntity.cycles
    && myEntity.cycles[cycleInView]
        ? myEntity.cycles[cycleInView].techData
        : null;

    const lastCycle = myEntity ? myEntity.last_cycle : null

    const handleOnClick = (cycleId) =>{
        setCycleInView(cycleId);
        setIsPastReport(cycleId !== myEntity.last_cycle.cycle)

    }

    useEffect(()=>{
        if(cycleInView && myEntity && myEntity.cycles && !myEntity.cycles[cycleInView]){
            dispatch(fetchRiskCycleReport({
                customerId: customerIdToUse,
                cycleId: cycleInView
            }))

        }

    }, [cycleInView])

    useEffect(()=>{
        // if(cycleInView !== lastCycle
        // || !sortedHistory.map(history=> history.cycle).includes(cycleInView)){
        setCycleInView( myEntity
            && myEntity.last_cycle
            && myEntity.last_cycle.cycle);
        // }
    },[entityInView])

    useEffect(()=>{

        if(cycleInView) {
            if (myEntity
                && authUser
                && bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", myEntity.id)
                //TODO: restore this check for Lite subscription once we update such that all tiles on tech page only rely on summary data (see Slack convo https://breachbits.slack.com/archives/GLM5SQC2Z/p1657044367751359)
                // && (doesUserHaveALiteSubscriptionOrHigher || isAdmin || isStaff)
                && myEntity.settings
                && myEntity.cycles
                && myEntity.cycles[cycleInView] //if there is already a cycle
                && !loadingCycles[cycleInView]
                && !loadingCycleDetails[cycleInView] //if not already loading them
            ) {
                // console.log("Fetching tech data for last cycle (",myEntity.settings.last_cycle_id,") is empty, fetching.");
                const techData = myEntity.cycles[cycleInView].techData
                //determine what page should be fetched.
                var pageNumToFetch = null;

                //if there is no techData, then fetch page 1.
                if (!techData) { //if no tech data
                    pageNumToFetch = 1;
                } else if ( //if there are pages that have not yet been fetched (first version of this Dec '21 will be simple and assume previous pages have been fetched)
                    //TODO: Logic of this should be more robust. Figure out how to tell which records are missing so you can fetch the correct page?
                    //look at the techData meta to see the highest page number that has been fetched
                    //compare this to the number of pages available
                    //if there are more pages to fetch
                    techData.meta
                    && techData.meta.highestPageFetched
                    && techData.meta.pages
                    && techData.meta.highestPageFetched < techData.meta.pages
                    // && techData.meta.pages > 2  //why was this line in there? Only fetch if 3 or more pages? seems like should have been > 1
                ) {
                    //set the next page to fetch as the next highest page
                    pageNumToFetch = techData.meta.highestPageFetched + 1;

                    //some load times can be long - give users occasional notifications
                    //every 10rd page, let them know.
                    // if (pageNumToFetch % 30 === 0) {
                    //     const percentCompleteLoading = Math.floor(pageNumToFetch/techData.meta.pages * 100) ;
                    //     showBBNotification(INFO, "Loading BreachRisk™ Technical In Progress", `${percentCompleteLoading}% complete, now fetching segment ${pageNumToFetch} of ${techData.meta.pages}`, false);
                    // }


                } else if (
                    techData.meta
                    && techData.meta.highestPageFetched
                    && techData.meta.pages
                    && techData.meta.highestPageFetched >= techData.meta.pages) {

                    //no need to fetch a page because highest page meet or exceeds max pages.
                    console.log("All tech details pages have been fetched. Won't fetch.", techData.meta.highestPageFetched, "out of", techData.meta.pages);
                    pageNumToFetch = null;

                    //if there were a lot of pages, let them know loading is complete
                    // if (techData.meta.pages > 2) {
                    //     // const percentCompleteLoading = Math.floor(pageNumToFetch/techData.meta.pages) * 100;
                    //     showBBNotification(SUCCESS, "Loading BreachRisk™ Technical Complete", `Loading complete. ${techData.meta.pages} data segments loaded.`, false);
                    // }

                } else {
                    console.warn("brbusiness/index.js Unexpected reason to not fetch another tech details page. Will not fetch. techData", techData, "pageNumToFetch", pageNumToFetch, "myEntity", myEntity, "customerIdToUse", customerIdToUse)
                    pageNumToFetch = null;
                }

                //if we got a valid page number, fetch the details
                if (pageNumToFetch) {
                    console.log("Fetching details page", pageNumToFetch);
                    dispatch(fetchRiskCycleDetailsPagewise(
                        cycleInView,
                        customerIdToUse,
                        pageNumToFetch
                    ));
                }
            }
        }

    }, [cycleInView, techData, loadingCycleDetails, myEntity, loadingCycles]);


    console.log("Viewing Technical Data page. Tech Data is", techData, " cycleInView", cycleInView, " sorted history is", sortedHistory, );
    // console.log("View technical data page, myEntity is", myEntity);

    return (
        // <MultiBoardWrapper customer={customer}>
        <div className="app-wrapper">
      <div className="animated fadeIn animation-duration-7">
          <div className="row">
              <div className={"col-8 align-self-center"}>
                  <div className={"mx-0 px-0"}>
                      <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>
                      {/*<h2>Technical Data</h2>*/}
                      <h3>{!bbIsEntityAwaitingFirstScoreCycle(myEntity) && <> {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.last_cycle_datetime, "shortFullMonth") : ""} | </>}{myEntity ? myEntity.name : ""}
                          <span>
                              <BRCompanyScoreVerifiedBadge
                                  entityId={entityInView}
                                  hideDescription
                                  fontSizeOverride={"1.0em"}
                                  inline
                              />
                          </span>
                      </h3>
                      <h2>
                          {/*<Tooltip title={`This BreachRisk™ Score is ${parseFloat(breachRiskScore).toFixed(1)} out of 10. Higher numbers indicate a higher relative risk that a cyber breach will occur in the foreseeable future.`}>*/}
                          <span>BreachRisk™ Score: <strong>{parseFloat(breachRiskScore).toFixed(1)}</strong><small> /10</small></span>
                          {/*</Tooltip> */}
                          &nbsp;{myEntity ?
                          <Tooltip heading={"Risk Categories"}
                                   width={"400px"}
                                   examples={[
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-lowest"}>Very Low Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-low"}>Low Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-medium"}>Medium Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-high"}>High Risk</Badge></p>,
                                           text: null,},
                                       {icon: <p style={{fontSize: "8px"}}><Badge color={"bb-risk-highest"}>Very High Risk</Badge></p>,
                                           text: null,},
                                   ]}>
                              <span><Badge color={bbTranslateBreachRiskScoreToColor(breachRiskScore)}>{breachRiskCategory} Risk</Badge></span></Tooltip>
                          : <Skeleton />
                      } &nbsp; &nbsp; {myEntity ?
                          <BRFidelityBadge cycleObject={lastCycle}/> : null
                      }
                          <span>
                              <BRCompanyScopeProgressBadge
                                  entityId={entityInView}
                                  hideDescription
                                  fontSizeOverride={"1.5em"}
                                  inline
                              />
                          </span>
                      </h2>
                  </div>
                  {(portfolioView && (isAdmin || isTrustedAgentForThisEntity)) || !portfolioView
                      ? <p>Identify anomalies quickly from the hacker's perspective, and see where existing security controls are thwarting attackers. <strong>You should use caution if you choose to share these details, since this information could give an attacker a significant advantage.</strong></p>
                  : null}
              </div>
              <div className={"col-4 align-self-center"}>
                  <h3>Pinpoint technical findings. <Tooltip heading={"Technical Details"} link={'/board/userguide#technicalData'}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                  <p>BreachRisk™ Technical provides precise findings designed optimize the find-fix-verify cycle for security technicians. </p>
                  {isCycleOngoing
                      ?   <h5>Next Report Available: {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.ongoing_cycle_complete_datetime, "shortFullMonth") : ""}</h5>

                      : <h5>Next Assessment Start: {myEntity && myEntity.settings ? bbFormattedDateString(myEntity.settings.next_cycle_datetime, "shortFullMonth") : ""}</h5>
                  }
                  <CycleProgressStepper/>
              </div>
          </div>
          {(portfolioView && (isAdmin || isTrustedAgentForThisEntity)) || !portfolioView
              ? <>

                  <hr/>

                  <VerifiedOwnershipRequiredDialog>
                  <BreachRiskScoreCyclePendingModal entity={myEntity} isBRPView={portfolioView}>
                      {portfolioView === false
                      // && (isAdminStaff || hasPremiumSubscription)
                          && isAdminStaff
                      && sortedHistory
                      && sortedHistory.length > 1
                          ? <span title={"View past reports to track your progress and see how your threats have changed over time."}>
                      <div className={"row mb-1 pb-1 align-self-center"}>
                      <div className={"col-6 text-center align-self-center"}>
                          <h1>Viewing Report For:  {myEntity
                          && cycleInView
                          && myEntity
                          && myEntity.cycles
                          && myEntity.cycles[cycleInView]
                          && myEntity.cycles[cycleInView].summary
                              ? bbFormattedDateString(myEntity.cycles[cycleInView].summary.cycle_datetime, "shortFullMonth")
                              : <Skeleton/>}</h1>
                      </div>

                      <div style={{marginTop: "-12px",}} className={"col-6 p-0 align-self-center"}>
                          {sortedHistory && sortedHistory.length > 1 ?
                              <Select

                                  placeholder={"Select a report date to view..."}
                                  options={sortedHistory.map((cycle)=>{
                                      return {
                                          label: bbFormattedDateString(cycle.cycle_date, "shortFullMonth"),
                                          value: cycle.cycle,
                                      }}
                                  )}
                                  onChange={(value)=> handleOnClick(value.value)}/>

                              : <em>No Past Reports Available</em>}
                      </div>
                  </div>
                  <br/>
                  </span>
                          :null
                      }

                      <h1>Threat Analysis</h1>
                      <p>Threat Vectors are formed when attackers have an <em>opportunity</em> <strong>and</strong> <em>capability</em> to cause a breach. Eliminating or mitigating threats reduce risk.</p>
                      <div className="row">

                          <div className="col-sm-4 col-12">
                              <TileBreachRiskTechDataPieVectorTypes cycleId={cycleInView}/>
                          </div>
                          <div className="col-sm-4 col-12">
                              <TileBreachRiskTechDataPieVectorServices cycleId={cycleInView}/>
                          </div>
                          <div className="col-sm-4 col-12">
                              <TileBreachRiskTechDataPieVectorStatus cycleId={cycleInView}/>
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-12">
                              {/*<DisableChildrenIfDoesntHaveAccessToSubscriptionLevel subscriptionNameOrId="BRfB" premium>*/}
                                <BRThreatsTechnicalTable portfolioView={portfolioView} cycleId={cycleInView}/>
                              {/*</DisableChildrenIfDoesntHaveAccessToSubscriptionLevel>*/}
                          </div>
                      </div>
                      {!portfolioView &&
                              <Row>
                                  <Col>
                                      <DisableChildrenIfDoesntHaveAccessToSubscriptionLevel lite>
                                          <ThreatVectorsTechHistoryChart entity={entityInView}/>
                                      </DisableChildrenIfDoesntHaveAccessToSubscriptionLevel>
                                  </Col>
                              </Row>
                      }

                      <hr/>
                      <h1 id={"tourStepYourCyberSpace"}>Your Cyberspace - Attack Surface</h1>
                      <p>Attackers can only attack what they can find. Attackers may target your cyberspace specifically or they may happen upon your cyberspace without knowing it is yours.</p>

                      <div className="row" >

                          {/*<div className="col-sm-4 col-12">*/}
                          {/*    <TileBreachRiskTechDataPieVectorTypes/>*/}
                          {/*</div>*/}
                          <div className={"col-2"}/>
                          <div className="col-sm-4 col-12">
                              <TileBreachRiskTechDataPieAllServices cycleId={cycleInView}/>
                          </div>
                          <div className="col-sm-4 col-12">
                              <TileBreachRiskTechDataPieAllPorts cycleId={cycleInView}/>
                          </div>
                      </div>
                      <div className="row" id={"tourStepCyberSpaceTrendsScrollHeader"}>

                          <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
                              <TileBreachRiskTechDataNumTargets cycleId={cycleInView}/>
                          </div>
                          <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
                              <TileBreachRiskTechDataCountServices cycleId={cycleInView}/>
                          </div>
                          <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
                              <TileBreachRiskTechDataCountHighRiskServices cycleId={cycleInView}/>
                          </div>
                          <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
                              <TileBreachRiskTechDataNumSubdomains cycleId={cycleInView}/>
                          </div>
                          <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
                              <TileBreachRiskTechDataNumVulnerabilities cycleId={cycleInView}/>
                          </div>
                          <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12">
                              <TileBreachRiskTechDataNumVulnerableTargets cycleId={cycleInView}/>
                          </div>

                      </div>

                      {/*<EarlyAccessWrapper>*/}
                      {!portfolioView &&
                          <Row id={"tourStepCyberSpaceTrends"}>
                              <Col>
                                  <DisableChildrenIfDoesntHaveAccessToSubscriptionLevel free>
                                    <AttackSurfaceTrendsTechHistoryChart entity={entityInView}/>
                                  </DisableChildrenIfDoesntHaveAccessToSubscriptionLevel>
                              </Col>
                          </Row>}
                      {/*</EarlyAccessWrapper>*/}

                      {/*{portfolioView && (isAdmin || isTrustedAgent)*/}
                      {/*    ? <TileComingSoon subtitle={"You are an Admin or Trusted Agent. Active Hosts table is being upgraded for Admins and Trusted Agents."} />*/}
                      {/*    : <>*/}

                              <div className="row" >
                                  <div className="col-12" id={"tourTechTargetsTable"}>
                                      <BRTechnicalTargetsTable portfolioView={portfolioView} cycleId={cycleInView}/>
                                  </div>
                              </div>
                      {/*    </>*/}
                      {/*}*/}




                      <div className="row" id={"tourServicesTable"}>
                          <div className="col-12">
                              <BRServicesTechnicalTable portfolioView={portfolioView} cycleId={cycleInView}/>
                          </div>
                      </div>
                      <div className="row" id={"tourSubdomainsTable"}>
                          <div className="col-12">
                              <BRSubdomainsTechnicalTable portfolioView={portfolioView} cycleId={cycleInView}/>
                          </div>
                      </div>
                      <hr/>
                      <h1>Other Context</h1>
                      <p>Attackers consider all types of information in order to build an understanding of the prevailing circumstances when planning attacks, even information that might not directly lead to a breach.</p>

                      <div className="row" id={"tourStepBRVulnsTable"}>
                          <div className="col-12" >
                              <BRVulnerabilitiesTable portfolioView={portfolioView} cycleId={cycleInView}/>
                          </div>
                      </div>

                  </BreachRiskScoreCyclePendingModal>
                      </VerifiedOwnershipRequiredDialog>
              </>
              : <>
                  <br/>
                  <br/>
                  <br/>
                  <Tooltip title={"If you need these details, this company will need to approve a request."} link={`https://support.breachbits.com/knowledge/requesting-access`}>
                      <h2 className={"text-center"}>You don't have Trusted Agent privileges for this Entity <InfoSharpIcon/></h2>
                  </Tooltip>

                  <br/>
                  <br/>
              </>
          }

      </div>
        </div>
        // </MultiBoardWrapper>
    )
}
export default Dashboard;